import React from 'react';
import { Trans } from "react-i18next";
import styles from "./GeneratorLabel.module.scss";
const GeneratorLabel = (props) => {
    return (React.createElement("label", { className: styles.label },
        React.createElement(Trans, { i18nKey: `${props.textKey}`, values: props.params })));
};
export default GeneratorLabel;
